import React from "react";

export const SectionHeader = ({ overline, title, kicker, align = "left", testid }) => {
  const alignCls = align === "center" ? "text-center mx-auto" : "";
  return (
    <div data-testid={testid} className={`max-w-3xl ${alignCls} mb-12 lg:mb-16`}>
      {overline && (
        <p className="text-xs tracking-[0.22em] uppercase text-[#E63946] font-semibold mb-5">
          {overline}
        </p>
      )}
      <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black tracking-tighter text-black leading-[1.05]">
        {title}
      </h2>
      {kicker && (
        <p className="mt-6 text-base lg:text-lg leading-relaxed text-zinc-600">
          {kicker}
        </p>
      )}
    </div>
  );
};

export const PageHeader = ({ overline, title, kicker }) => (
  <section className="border-b border-black/10 bg-white">
    <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-24 pb-20 lg:pt-32 lg:pb-28 grid lg:grid-cols-12 gap-10">
      <div className="lg:col-span-3">
        {overline && (
          <p className="text-xs tracking-[0.22em] uppercase text-[#E63946] font-semibold">
            {overline}
          </p>
        )}
        <p className="mt-3 font-mono-tech text-[11px] text-zinc-500">
          /{(overline || "").toLowerCase().replace(/\s+/g, "-")}
        </p>
      </div>
      <div className="lg:col-span-9">
        <h1 className="font-display text-4xl sm:text-5xl lg:text-7xl font-black tracking-tighter text-black leading-[0.95]">
          {title}
        </h1>
        {kicker && (
          <p className="mt-8 text-lg lg:text-xl leading-relaxed text-zinc-600 max-w-3xl">
            {kicker}
          </p>
        )}
      </div>
    </div>
  </section>
);

export const Stat = ({ value, label }) => (
  <div className="border-t border-zinc-800 pt-6 first:border-t-0 sm:border-t-0 sm:border-l sm:pl-8 sm:pt-0 first:sm:border-l-0 first:sm:pl-0">
    <p className="font-display text-4xl lg:text-5xl font-black text-white tracking-tighter">
      {value}
    </p>
    <p className="mt-3 text-xs tracking-[0.22em] uppercase text-zinc-400">{label}</p>
  </div>
);
